export const ENTERPRISE_TAG_TYPES = ["scim"] as const;
